import { caseStudies } from "@/mocks/collections";
import Reveal from "@/components/base/Reveal";
import MagneticTilt from "@/components/base/MagneticTilt";

// Deterministic per-index layout that tiles perfectly in a 3-col × 4-row grid
// with no empty cells. Works for exactly 5 case studies.
const tileClass = [
  "md:col-span-2 md:row-span-2", // 0: big featured (top-left)
  "md:col-span-1 md:row-span-1", // 1: top-right top
  "md:col-span-1 md:row-span-1", // 2: top-right bottom
  "md:col-span-1 md:row-span-2", // 3: bottom-left tall
  "md:col-span-2 md:row-span-2", // 4: bottom-right wide-tall
];

export default function GallerySection() {
  return (
    <section
      id="gallery"
      className="relative w-full bg-[#2563eb] border-t border-white/15 py-24 md:py-32 px-6 md:px-12"
    >
      <div className="max-w-7xl mx-auto">
        <Reveal className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14 md:mb-20">
          <div className="max-w-2xl">
            <div className="font-label text-[11px] text-[#93c5fd] mb-5">
              GALLERY / 今月の部室（新宿）
            </div>
            <h4 className="font-jp text-5xl md:text-6xl lg:text-[64px] leading-[1.2] text-white font-medium">
              <a href="#gallery" className="cursor-pointer lum-underline">
                こんな場所に、<br />集まります。
              </a>
            </h4>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 md:auto-rows-[220px] lg:auto-rows-[260px] gap-3 md:gap-3">
          {caseStudies.map((c, i) => (
            <Reveal
              key={c.id}
              delay={Math.min(5, i + 1) as 1 | 2 | 3 | 4 | 5}
              className={`${tileClass[i] ?? "md:col-span-1 md:row-span-1"} aspect-[4/3] md:aspect-auto md:h-full`}
            >
              <MagneticTilt
                maxTilt={4}
                lift={4}
                className="group relative block overflow-hidden rounded-lg bg-[#1d4ed8] w-full h-full"
              >
                <div
                  className="absolute inset-0 bg-cover bg-center transition-transform duration-[1400ms] ease-out group-hover:scale-[1.07]"
                  style={{ backgroundImage: `url(${c.image})` }}
                />

                {/* Mouse-following halo */}
                <span className="lum-tilt-glow" />
              </MagneticTilt>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}